import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem('theme');
    if (stored) return stored;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  const [readerSettings, setReaderSettings] = useState(() => {
    const stored = localStorage.getItem('readerSettings');
    const defaults = {
      fontSize: 'lg',
      lineHeight: 'relaxed',
      scriptMode: 'kanji',
      readerTheme: 'default',
      fontFamily: 'noto-serif',
      sentencesPerPage: 50,
    };
    return stored ? { ...defaults, ...JSON.parse(stored) } : defaults;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('readerSettings', JSON.stringify(readerSettings));
  }, [readerSettings]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const updateReaderSettings = (updates) => {
    setReaderSettings(prev => ({ ...prev, ...updates }));
  };

  return (
    <ThemeContext.Provider value={{
      theme,
      setTheme,
      toggleTheme,
      readerSettings,
      updateReaderSettings
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
